// extracted by mini-css-extract-plugin
export default {"card":"AboutCards_card__hLI+M"};